import SocialPublish from "../custom-components/SocialPublish/SocialPublish";
import {useSelectedCard} from "../../contexts/SelectedCardContext";

export default function SocialPublishPage(){
    const {logicClip, updateLogicClipDescription} = useSelectedCard()

    return (logicClip && <SocialPublish
        logicClip={logicClip}
        onLogicClipDescriptionChange={updateLogicClipDescription}
    />)
}